<div class="google-profile-wrapper">
  
  <!-- Pinned Close Button -->
  <button mat-icon-button class="profile-close-btn" (click)="close()" title="Fermer">
    <mat-icon>close</mat-icon>
  </button>

  <!-- Google Account Centered Info -->
  <div fxLayout="column" fxLayoutAlign="center center" style="text-align: center; margin-top: 10px;">
    <div class="avatar-ring">
      <img *ngIf="userinfo?.profile == null || userinfo?.profile == ''" [src]="profileImageBase64 || 'assets/images/profile.jpg'" class="avatar-img" />
      <img *ngIf="userinfo?.profile != null && userinfo?.profile != ''" [src]="userinfo?.profile" class="avatar-img" />
    </div>
    <h2 class="profile-name">{{userinfo?.nom}} {{userinfo?.prenom}}</h2>
    <p class="profile-email">{{userinfo?.email || '–'}}</p>
    <div style="margin-top: 10px;">
      <span class="badge-agency-google">
        {{agence?.nomagence || agence?.codeagence || agence}}
      </span>
    </div>
  </div>

  <!-- Details Card List -->
  <div class="google-details-list">
    <div class="detail-row">
      <mat-icon class="row-icon">phone</mat-icon>
      <div class="row-content">
        <span class="row-label">Telephone</span>
        <span class="row-value">{{userinfo?.phone || '–'}}</span>
      </div>
    </div>
    
    <div class="detail-row">
      <mat-icon class="row-icon">badge</mat-icon>
      <div class="row-content">
        <span class="row-label">CNI</span>
        <span class="row-value">{{userinfo?.cni || '–'}}</span>
      </div>
    </div>

    <div class="detail-row">
      <mat-icon class="row-icon">restore</mat-icon>
      <div class="row-content">
        <span class="row-label">N° Session</span>
        <span class="row-value">{{session || '–'}}</span>
      </div>
    </div>
  </div>

  <!-- Signature Card -->
  <div fxLayout="column" style="padding: 16px; border: 1px solid #ddd; margin: 16px; border-radius: 8px;">
    <h4 style="margin-top: 0;">Signature</h4>
    <div *ngIf="!showSignaturePad">
      <img *ngIf="userinfo?.signature" 
           [src]="userinfo?.signature" 
           style="max-height: 100px; border: 1px dashed #ccc; padding: 4px; margin-bottom: 8px;" />
      <br *ngIf="userinfo?.signature" />
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button mat-stroked-button color="primary" (click)="showSignaturePad = true; signatureStatus = false;">
          <mat-icon>draw</mat-icon> Dessiner (Souris)
        </button>
        <button mat-stroked-button color="accent" (click)="showSignaturePad = false; sign();">
          <mat-icon>tablet_mac</mat-icon> Utiliser Pad
        </button>
      </div>
    </div>

    <!-- Souris / Tactile Pad -->
    <div [hidden]="!showSignaturePad" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top: 10px; width: 100%;">
      <div style="border: 2px dashed #999; background: #fafafa; width: 300px; height: 150px; margin: 0 auto; touch-action: none;">
        <signature-pad #sigPad [options]="signaturePadOptions"></signature-pad>
      </div>
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" style="margin-top: 10px; width: 100%;">
        <button mat-raised-button color="primary" (click)="saveSignature(sigPad)" [disabled]="loadingSignature">Enregistrer</button>
        <button mat-stroked-button color="warn" (click)="clearSignature(sigPad)">Effacer</button>
        <button mat-button (click)="showSignaturePad = false">Annuler</button>
      </div>
    </div>

    <!-- PenPower SDK Pad -->
    <div *ngIf="signatureStatus" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top: 10px; width: 100%;">
        <canvas #liveSignatureCanvas width="400" height="200" 
                style="border: 1px solid #ccc; background: #fff; border-radius: 4px; max-width: 100%; object-fit: contain;">
        </canvas>
        
        <div style="width: 100%; max-width: 400px; display: flex; flex-direction: column; align-items: center;">
          <span style="color: #666; font-size: 0.85em; margin-bottom: 4px;">Fermeture automatique dans {{signatureTimeLeft}}s</span>
          <div style="width: 100%; height: 6px; background-color: #eee; border-radius: 3px; overflow: hidden; display: flex; justify-content: flex-start;">
             <div [style.width.%]="(signatureTimeLeft / 120) * 100"
                  [style.background-color]="signatureTimeLeft > 60 ? '#4caf50' : (signatureTimeLeft > 30 ? '#ff9800' : '#f44336')"
                  style="height: 100%; transition: width 1s linear, background-color 1s ease;">
             </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" style="margin-top: 15px; width: 100%; flex-wrap: wrap; justify-content: center;">
         <button type="button" mat-raised-button color="warn" (click)="cancelSignatureManual()">
            <mat-icon>cancel</mat-icon> Annuler
         </button>
         <button type="button" mat-raised-button (click)="clearLiveCanvas()" style="background: #f0ad4e; color: white;">
            <mat-icon>clear</mat-icon> Effacer
         </button>
         <button type="button" mat-raised-button color="primary" (click)="confirmSignatureManual()">
            <mat-icon>check_circle</mat-icon> Confirmer
         </button>
      </div>
      <div style="margin-top: 10px; color: #666; font-size: 12px; text-align: center; width: 100%;">
         <mat-spinner diameter="16" style="display: inline-block; vertical-align: middle; margin-right: 5px;"></mat-spinner>
         En direct : Signez sur le pad PenPower...
      </div>
    </div>
  </div>

  <!-- Change Password Trigger -->
  <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 20px;">
    <button mat-stroked-button class="google-action-btn" (click)="changePassword()">
      <mat-icon>{{ chgPassword ? 'close' : 'lock_open' }}</mat-icon>
      {{ (chgPassword ? 'Annuler' : ('password' | translate) + ' - ' + ('modifier' | translate)) }}
    </button>
  </div>

  <!-- Password form card -->
  <div class="google-password-card" *ngIf="chgPassword" [formGroup]="passwordForm">
    <h4 class="password-title">{{'NewPassword' | translate}}</h4>
    <div fxLayout="column" fxLayoutGap="12px">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{'currentPass' | translate}}</mat-label>
        <input matInput formControlName="currentPassword" type="password">
        <mat-icon matSuffix style="font-size: 18px;">lock_open</mat-icon>
      </mat-form-field>
      
      <div fxLayout="row" fxLayoutGap="12px">
        <mat-form-field appearance="outline" fxFlex="50">
          <mat-label>{{'newPass' | translate}}</mat-label>
          <input matInput formControlName="newPassword" type="password">
          <mat-icon matSuffix style="font-size: 18px;">vpn_key</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="50">
          <mat-label>{{'tryNewPass' | translate}}</mat-label>
          <input matInput formControlName="confirmPassword" type="password">
          <mat-icon matSuffix style="font-size: 18px;">vpn_key</mat-icon>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-flat-button color="primary" class="google-save-btn" [disabled]="passwordForm.invalid || !validform" (click)="updatepassword()">
          {{'Confirmer' | translate}}
        </button>
      </div>
    </div>
  </div>

</div>

